const actionTypeIdentifier = "0F24CDEC-129E-4300-8F9A-C17F6D41866B";

export const setInvoiceHistoryLogsLoading = `SET-INVOICE-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getInvoiceHistoryLogs = `GET-INVOICE-HISTORY-LOGS-${actionTypeIdentifier}`;
export const resetInvoiceHistory = `RESET-INVOICE-HISTORY-${actionTypeIdentifier}`;
export const setInvoiceHistoryColSearchStr = `SET-INVOICE-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
export const setInvoiceHistoryPageSize = `SET-INVOICE-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;